// extracted by mini-css-extract-plugin
export default {"iframe-player":"IframePlayer_iframe-player__a+JA3","relative":"IframePlayer_relative__s7trO"};